import { useOptionalUserState } from '../../../../state/user-state/user-state';
import { userStateAdapter } from '../../../../state/user-state/user-state-adapter';

/**
 * Returns a value indicating whether the Design tool is enabled for the current user.
 */
function isDesignToolEnabled() {
  const snapshot = userStateAdapter.getSnapshot();
  if (snapshot.hasDesignToolAccessForCurrentProject()) {
    return true;
  }
  return !snapshot.isActiveRoleProjectUser();
}

/**
 * `useDesignTool` returns info about whether the user has access to the Design tool or whether the
 * tool is enabled (can be enabled without having access to the tool itself, in order to display
 * dialogs for instance).
 */
const useDesignTool = () => {
  const userState = useOptionalUserState();
  const hasAccess = userState?.hasDesignToolAccessForCurrentProject() ?? false;

  return {
    hasAccess,
    isEnabled: isDesignToolEnabled(),
  };
};

export { useDesignTool };
